import { Link, useTheme } from '@mui/material';

import { ATSAutomationListTestIds } from 'data-testids/ATS';
import { AddAutomationButtonProps } from 'features/Automations/types';

export const AddAutomationButton: React.FC<AddAutomationButtonProps> = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Link
      underline="none"
      onClick={onClick}
      data-testid={ATSAutomationListTestIds.ADD_ANOTHER_AUTOMATION_LINK}
      sx={{
        color: theme.palette.secondary.dark,
        cursor: 'pointer',
        fontWeight: theme.typography.fontWeightMedium,
      }}
    >
      + Add another automation
    </Link>
  );
};
